import enUS from './i18n/en.json'
import esMX from './i18n/es.json'

export default {
  'en': enUS,
  'es': esMX
}
